import _ from 'lodash'
import {
  STORE_ORGANIZATION_ID,
  CLEAN_ORGANIZATION_ID,
} from '../../constants/actionTypes'

const initialState = {
  organizationId: null,
}

const organizationAuditPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_ORGANIZATION_ID:
      return Object.assign({}, state, {
        organizationId: _.get(action.organization, 'id', null),
      })
    case CLEAN_ORGANIZATION_ID:
      return Object.assign({}, initialState)
    default:
      return state
  }
}

export default organizationAuditPageReducer
